import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Categories } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class CategoriesModule extends VuexModule {
    @Action
    [Categories.showCategories](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/categories/`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Categories.insertCategories](values,onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/categories/insert`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Categories.updateCategories](values,onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/categories/update`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Categories.deleteCategories](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/categories/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Categories.uploadCategoriesIcon](values,onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/categories/uploadIcon`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Categories.listCategories]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/api/v1/categories/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Categories.restoreToDefault](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/categories/restoreToDefault`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    
}

